import React from 'react';
import { IExcludedPaceDates } from '../store/visualisations/getExcludedPaceDatesRef';

const ExcludedPaceDatesContext = React.createContext<IExcludedPaceDates>({
  dateRanges: [],
});

export default ExcludedPaceDatesContext;
